module.exports = __webpack_public_path__ + "media/images/partner/supporter/albrecht_beckers-c7db8e5c6533af1f403bc4daaa4c8692.png";